import React, { useState } from 'react';
import './Homepanel.css';

const Homepanel = () => {
  const [mainSliderImages, setMainSliderImages] = useState(["", "", "", "", ""]);
  const [keyInitiativesText, setKeyInitiativesText] = useState('');
  const [dpiitText, setDpiitText] = useState('');
  const [adImages, setAdImages] = useState(["", "", "", "", ""]);
  const [status, setStatus] = useState('');
  const [youtubeURL, setYoutubeURL] = useState('');

const isValidYouTubeURL = (url) => {
  const pattern = /^(https?:\/\/(?:www\.)?youtube\.com\/(?:[^\/\n\s]+\/\S+|\S+(\?v=|\/videos\/)\S+))$/i;
  return pattern.test(url);
};

  const isValidURL = (url) => {
    const pattern = /^(https?:\/\/)[\w\-]+(\.[\w\-]+)+[/#?]?.*$/i;
    return pattern.test(url);
  };

  const handleSubmit = async () => {
    // Prepare the data object, including all fields (even if they were only partially changed)
    const data = {
      mainSliderImages,
      keyInitiativesText,
      dpiitText,
      adImages,
      youtubeURL,
    };
    if (youtubeURL && !isValidYouTubeURL(youtubeURL)) {
      setStatus('Please enter a valid YouTube URL.');
      return;
    }
    // Validate the URLs for the images (main slider and ad images)
    if (data.mainSliderImages.some((img) => img && !isValidURL(img))) {
      setStatus('Please enter valid URLs for all main slider images.');
      return;
    }

    if (data.adImages.some((img) => img && !isValidURL(img))) {
      setStatus('Please enter valid URLs for all ad images.');
      return;
    }

    try {
      const response = await fetch('/api/admin/update-content', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setStatus('Content updated successfully!');
      } else {
        setStatus('Update failed. Try again.');
      }
    } catch (error) {
      setStatus('Error occurred. Try again later.');
    }
  };

  const handleSliderImageChange = (index, value) => {
    const newImages = [...mainSliderImages];
    newImages[index] = value;
    setMainSliderImages(newImages);
  };

  const handleAdImageChange = (index, value) => {
    const newImages = [...adImages];
    newImages[index] = value;
    setAdImages(newImages);
  };

  return (
    <div className="admin222">
      <h2 className="header222">Home page</h2>

      {/* Main Slider Image Uploads */}
      <div className="group222">
        <h3>Main Slider Images</h3>
        {[...Array(5)].map((_, index) => (
          <div key={index} className="group222">
            <label>Image {index + 1}</label>
            <input
              type="text"
              placeholder={`Enter Image ${index + 1} URL`}
              value={mainSliderImages[index]}
              onChange={(e) => handleSliderImageChange(index, e.target.value)}
              className="field222"
            />
          </div>
        ))}
      </div>

      {/* Key Initiatives Text */}
      <div className="group222">
        <h3>Key Initiatives Text</h3>
        <textarea
          value={keyInitiativesText}
          onChange={(e) => setKeyInitiativesText(e.target.value)}
          className="field222"
        />
      </div>

      {/* DPIIT Endorsement Text */}
      <div className="group222">
        <h3>DPIIT Endorsement Text</h3>
        <textarea
          value={dpiitText}
          onChange={(e) => setDpiitText(e.target.value)}
          className="field222"
        />
      </div>

      {/* Ad Image Uploads */}
      <div className="group222">
        <h3>Ad Images</h3>
        {[...Array(2)].map((_, index) => (
          <div key={index} className="220-image-input-group">
            <label>Ad Image {index + 1}</label>
            <input
              type="text"
              placeholder={`Enter Ad Image ${index + 1} URL`}
              value={adImages[index]}
              onChange={(e) => handleAdImageChange(index, e.target.value)}
              className="field222"
            />
          </div>
        ))}
      </div>
      <div className="group222">
  <h3>YouTube URL</h3>
  <input
    type="text"
    placeholder="Enter YouTube URL"
    value={youtubeURL}
    onChange={(e) => setYoutubeURL(e.target.value)}
    className="field222"
  />
   </div>

      <button className="button222" onClick={handleSubmit}>
        Update Content
      </button>

      {status && <p>{status}</p>}
    </div>
  );
};

export default Homepanel;
